


import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { FaSearch, FaBell } from "react-icons/fa";
import { FiMenu } from "react-icons/fi";
import toast, { Toaster } from "react-hot-toast";
import profile2 from "../../assets/profile.svg";
import { getAdminProfile } from "../../api/apiServices";

export default function Header({ setIsOpen }) {
  const location = useLocation();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notifications, setNotifications] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [lastPlayed, setLastPlayed] = useState(0); // ✅ Track last sound play time

  // Dynamic placeholder text
  const getPlaceholder = () => {
    const segments = location.pathname.split("/").filter(Boolean);
    const lastSegment = segments[segments.length - 1];

    if (lastSegment === "dashboard") return "Search anything in the dashboard";
    if (lastSegment)
      return `Search ${lastSegment.charAt(0).toUpperCase() + lastSegment.slice(1)} by name`;

    return "Search";
  };

  // Fetch profile
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const admin = await getAdminProfile();
        setProfile(admin.user);
      } catch (err) {
        console.error("Error fetching profile:", err);
        toast.error("Failed to load profile");
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-40 text-gray-600">
        Loading profile...
      </div>
    );
  }

  return (
    <div className="fixed top-0 left-0 lg:left-[297px] right-0 z-40 bg-white px-6 py-4 flex items-center justify-between border-b border-gray-200 h-[72px]">
      <Toaster position="top-right" reverseOrder={false} />

      {/* Mobile Menu Button */}
      <button
        className="lg:hidden text-2xl text-gray-700"
        onClick={() => setIsOpen(true)}
      >
        <FiMenu />
      </button>

      {/* Notification + Profile */}
      <div className="flex items-center space-x-6">

        {/* Profile */}
        {profile ? (
          <div className="flex items-center space-x-3">
            <div className="h-9 w-9 rounded-full overflow-hidden border border-gray-300">
              <img
                src={profile.image || profile2}
                alt="profile"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="text-left hidden sm:block">
              <h1 className="text-sm font-semibold text-gray-800">
                {profile.email}
              </h1>
              <p className="text-xs text-gray-500">{profile.role}</p>
            </div>
          </div>
        ) : (
          <div className="flex items-center space-x-3">
            <div className="h-9 w-9 rounded-full bg-gray-200 animate-pulse" />
            <div className="hidden sm:block">
              <div className="w-20 h-3 bg-gray-200 rounded mb-1 animate-pulse"></div>
              <div className="w-14 h-2 bg-gray-200 rounded animate-pulse"></div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}